import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

export type CreateStagedSmartCreateDraftResult = {
	contentId: string;
	type: 'page';
};

export const createStagedSmartCreateDraft = async (
	cloudId: string,
): Promise<CreateStagedSmartCreateDraftResult> => {
	const data = await performHttpFetch<{ id: number; type: 'page' }>({
		path: `/gateway/api/ex/confluence/${cloudId}/wiki/rest/internals/latest/smart-create/staged`,
		options: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ type: 'page' }),
		},
	});

	return {
		contentId: String(data.id), // id is number but contentId is string
		type: data.type,
	};
};
